import React from 'react'
import * as Sentry from '@sentry/react'
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router'
import {
  setClientFailureSurface,
  type ClientFailureSurface,
} from '@/shared/lib/reportUnexpectedClientFailure'

export type InitBrowserSentryArgs = {
  surface: ClientFailureSurface
  dsn: string | undefined
  environment: string | undefined
  replayEnabled?: boolean
}

export function initBrowserSentry(args: InitBrowserSentryArgs): boolean {
  const { dsn, environment, surface, replayEnabled = false } = args

  if (!dsn || !environment) {
    return false
  }

  setClientFailureSurface(surface)

  const integrations = [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ]

  if (replayEnabled) {
    integrations.push(Sentry.replayIntegration())
  }

  Sentry.init({
    dsn,
    environment,
    integrations,
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  })

  Sentry.setTag('surface', surface)

  return true
}
